import React, { Component } from 'react'
import { connect } from 'react-redux'
import { List, ListItem, ListItemText, ListItemIcon } from '@material-ui/core'
import { NavigateNext } from '@material-ui/icons'
import { fetchWorkflowList, fetchWorkflowInfo } from 'reducers/myJobs/reducer'
import CircleLoader from 'components/Loading/CircleLoader'
import withPromise from 'helpers/withPromise'

class WorkflowList extends Component {
  state = {
    isDialogOpen: false,
    workflowList: [],
    activeWorkflow: {
      id: null,
      title: '',
    },
  }

  componentDidMount() {
    const { fetchWorkflowList, activeSite } = this.props

    fetchWorkflowList({ activeSite })
  }

  shouldComponentUpdate(nextProps) {
    const { workflowList } = nextProps
    const { workflowList: prevWorkflowList } = this.props

    if (prevWorkflowList !== workflowList) {
      this.setState({
        workflowList,
      })

      return false
    }

    return true
  }

  handlePlanClick = workflowId => {
    const { fetchWorkflowInfo, onSetForm, goForward, activeSite } = this.props

    return withPromise(fetchWorkflowInfo, {
      id: workflowId,
      activeSite,
    }).then(workflow => {
      if (Object.prototype.hasOwnProperty.call(workflow, 'error')) {
        return Promise.resolve(workflow)
      }

      onSetForm(workflow)
      goForward(workflow.needs_locus || workflow.needs_locus_group ? 1 : 2)
    })
  }

  render() {
    const { workflowListLoader, workflowInfoLoader } = this.props
    const { workflowList } = this.state
    const workflowLoader = workflowListLoader || workflowInfoLoader

    if (workflowLoader) {
      return (
        <div className="loader-box">
          <CircleLoader loading={workflowLoader} />
        </div>
      )
    }

    return (
      <List disablePadding className="workflow-list">
        {workflowList.map(item => (
          <ListItem
            button
            key={`key_${item.id}`}
            className="workflow"
            onClick={() => this.handlePlanClick(item.id)}>
            <ListItemText primary={item.title} />
            <ListItemIcon>
              <NavigateNext />
            </ListItemIcon>
          </ListItem>
        ))}
      </List>
    )
  }
}

export default connect(
  state => ({
    workflowList: state.getIn(['myJobs', 'workflowList']),
    workflowListLoader: state.getIn(['myJobs', 'isWorkflowListLoad']),
    workflowInfoLoader: state.getIn(['myJobs', 'isWorkflowInfoLoad']),
    activeSite: state.getIn(['profile', 'myJobsFilters', 'site']),
  }),
  {
    fetchWorkflowList,
    fetchWorkflowInfo,
  },
)(WorkflowList)
